import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

export const TOKEN_KEY = "ceogpt_admin_token";

export const api = axios.create({
    baseURL: API,
    timeout: 20000,
});

api.interceptors.request.use((config) => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const isLoginCall = err?.config?.url?.endsWith("/auth/login");
            if (!isLoginCall) {
                localStorage.removeItem(TOKEN_KEY);
                if (
                    typeof window !== "undefined" &&
                    !window.location.pathname.startsWith("/admin/login")
                ) {
                    window.location.assign("/admin/login");
                }
            }
        }
        return Promise.reject(err);
    },
);

export function formatApiError(e) {
    const d = e?.response?.data?.detail;
    if (d == null) return e?.message || "Something went wrong.";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
            .join(" ");
    if (d && typeof d.msg === "string") return d.msg;
    return JSON.stringify(d);
}
